import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import LazyLoadingList from '../../components/common/LazyLoadingList';
import AuthManager from '../../../utils/AuthManager'
import General from '../../../utils/General'
import Event from "../../../utils/Event";
import ListLinkie from "../modals/ListLinkie";
import Confirm from "../modals/Confirm";
import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";
import FetchHelper from "../../../utils/FetchHelper";
import Url from "../../../utils/Url";

export default class Linkie extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      type: props.type,
      list: props.list,
      linkie: props.linkie,
      faviconFailed: false
    }
    this.list = React.createRef()
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState(nextProps)
  }

  _deleteLinkie(){
    let {
      list,
      selectedLinkie
    } = this.state

    Backend.deleteLinkie(selectedLinkie, list).then(() => {
      General.showNotification("Website Deleted")
      this.setState({
        showConfirmModal: false,
        selectedLinkie: null
      }, () => this.props.refresh())
    }).catch(e => {
      General.showNotification(e.message, false)
      this.setState({
        showConfirmModal: false,
        selectedLinkie: null
      })
    })
  }

  _renderPlaceholder(name){
    return <span>{name.charAt(0)}</span>
  }

  _isAIQuery(){
    return this.state.linkie?.linkie_type === 'ai_query'
  }

  _getQueryUUID(url){
    if(!url) return null
    let parts = url.split('/ai-queries/')
    return parts.length > 1 ? parts[1].replace(/\/$/, '') : null
  }

  _renderIcon(url){
    if (this._isAIQuery()) {
      return (
        <span className="ai-query-icon-container" style={{
          width: 38, height: 38, borderRadius: '8px', 
          backgroundColor: '#6f55ff', display: 'flex', 
          alignItems: 'center', justifyContent: 'center'
        }}>
          <img 
            src={require('../../../assets/media/icons/ai.png')} 
            alt="AI" 
            style={{width: 22, height: 22, filter: 'brightness(0) invert(1)'}}
          />
        </span>
      )
    }
    let favicon = Url.getFavIcon(url)

    return (
      <img
        src={favicon}
        onError={() => {this.setState({faviconFailed: true})}}
      />
    )
  }

  render(){
    let {
      type,
      linkie,
      faviconFailed,
      selectedLinkie,
      showConfirmModal,
      showListLinkieModal
    } = this.state

    let url = linkie.url
    if(url.startsWith("https://")){
      url = url.replace("https://", "")
    }else if(url.startsWith("http://")){
      url = url.replace("http://", "")
    }

    if(url.length > 50){
      url = url.slice(0, 50) + "..."
    }

    let isAI = this._isAIQuery()
    let name = linkie.name
    let fullUrl = linkie.url
    let displayUrl = isAI ? (linkie.prompt || url) : url

    return (
      <>
        <div className="col-auto symbol">
          <span>
            {
              faviconFailed ? this._renderPlaceholder(name) : this._renderIcon(fullUrl)
            }
          </span>
        </div>
        <div className="col link">
          <a
            href={isAI ? undefined : fullUrl}
            className="name text-gray-800 text-hover-primary fs-6 fw-bolder"
            onClick={e => e.preventDefault()}
          >
            {name}
          </a>
          <span className="url fw-bold d-block fs-7">{displayUrl}</span>
        </div>
        <div className="col-auto buttons">
          {
            type !== "system_popular" ?
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm w-80px fs-6"
                onClick={() => this.setState({
                  showConfirmModal: true,
                  selectedLinkie: linkie
                })}
              >
                Delete
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm w-80px fs-6 mx-2"
                onClick={() => {
                  if (isAI) {
                    let queryUUID = this._getQueryUUID(linkie.url)
                    Backend.getLinkie(linkie.id).then(detail => {
                      let listIds = detail.lists ? detail.lists.map(l => l.id) : []
                      Event.emit('SHOW_AI_QUERY_MODAL', {
                        query_uuid: queryUUID,
                        name: detail.name || linkie.name || '',
                        prompt: detail.prompt || linkie.prompt || '',
                        active: detail.active !== undefined ? detail.active : true,
                        list_ids: listIds,
                      })
                    }).catch(e => General.showNotification(e.message, false))
                  } else {
                    this.setState({
                      showListLinkieModal: true,
                      selectedLinkie: linkie
                    })
                  }
                }}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm w-80px fs-6"
                  onClick={() => {
                    if (isAI) {
                      Event.emit('SHOW_AI_RESPONSE_MODAL', linkie)
                    } else {
                      window.open(fullUrl, '_blank')
                    }
                  }}
              >
                View
              </button>
            </>
            :
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm w-80px fs-6 mx-2"
                onClick={() => window.open(fullUrl, '_blank')}
              >
                View
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm w-80px fs-6"
                onClick={() => Event.emit('SHOW_LINKIE_MODAL', {list: null, linkie: {name: linkie.name, url: linkie.url, list_ids: []}})}
              >
                Add
              </button>
            </>
          }

        </div>
        {
          showListLinkieModal &&
          <ListLinkie
            show={showListLinkieModal}
            linkie={selectedLinkie}
            onHide={() => {
              this.setState({
                showListLinkieModal: false,
                selectedLinkie: null
              }, () => this.props.refresh())
            }}
            onSaved={() => {
              this.setState({
                showListLinkieModal: false,
                selectedLinkie: null
              }, () => this.props.refresh())
            }}
          />
        }
        {
          showConfirmModal &&
          <Confirm
            show={showConfirmModal}
            onHide={() => {
              this.setState({ showConfirmModal: false })
            }}
            onConfirm={() => this._deleteLinkie()}
          />
        }
      </>
    )
  }
}
